(() => {
  'use strict';
  if (window.gmlCookiePreferencesReady) return;
  window.gmlCookiePreferencesReady = true;
  let loading;

  function getBanner() {
    if (typeof window.privacyBanner?.showPreferences === 'function') {
      return Promise.resolve(window.privacyBanner);
    }
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[src*="/privacy-banner/storefront-banner.js"]');
      const script = existing || document.createElement('script');
      let timeout;
      const cleanup = () => {
        clearTimeout(timeout);
        script.removeEventListener('load', loaded);
        script.removeEventListener('error', failed);
      };
      const failed = () => {
        cleanup();
        if (!existing) script.remove();
        reject(new Error('Privacy preferences could not be loaded.'));
      };
      const loaded = () => {
        if (typeof window.privacyBanner?.showPreferences !== 'function') return failed();
        cleanup();
        resolve(window.privacyBanner);
      };
      script.addEventListener('load', loaded);
      script.addEventListener('error', failed);
      timeout = setTimeout(failed, 10000);
      if (!existing) {
        script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
        script.async = true;
        document.head.append(script);
      }
    }).catch(error => {
      loading = undefined;
      throw error;
    });
    return loading;
  }

  function showControls() {
    document.querySelectorAll('[data-gml-cookie-preferences]').forEach(button => {
      button.hidden = false;
    });
  }

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-gml-cookie-preferences]');
    if (!button || button.disabled) return;
    const status = document.getElementById(button.getAttribute('aria-describedby'));
    event.preventDefault();
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) status.hidden = true;
    try {
      const banner = await getBanner();
      await banner.showPreferences();
    } catch {
      if (status) {
        status.textContent = status.dataset.error;
        status.hidden = false;
      }
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
  showControls();
  document.addEventListener('shopify:section:load', showControls);
})();
